<template>
  <div class="PageBox">
    <div class="ScrollBox">
		<van-nav-bar
		fixed
		:border="false"
		:title="$t('user.subordinate[8]')"
		left-arrow
		@click-left="$router.go(-1)"
		/>
      
      <van-cell class="mt10" :border="false" icon="cluster" :title="$t('user.subordinate[8]')"  />
      <table width="100%">
        <thead>
          <tr>
            <th>{{$t('user.subordinate[9]')}}</th>
            <th>{{$t('user.subordinate[10]')}}</th>
			<th>{{$t('user.subordinate[11]')}}</th>
            
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in reportData" :key="index">
            
            <td><em>{{item.username}}</em></td>
            <td>{{item.grade}}</td>
			<td>{{item.handle}}</td>
            
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MemberList',
  components: {
  },
  props: ["memberId"],
  data() {
    return {
		
      reportData:[],
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
	// console.log(this.memberId); 
	 var id = this.memberId;
	  // console.log(id); 
    this.$parent.navBarTitle = this.$t('user.subordinate[8]')
    this.$Model.Office(id,data=>{
      if(data.code==1){
        this.reportData = data.data
      }
    })
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    
  }
}
</script>
<style scoped>
table{
  background-color: #fff;
  text-align: center;
  margin-bottom: 20px;
}
table tr th{
  padding: 6px 5px;
  background-color: #fff;
  color: #333;
}
table tr td{
  border: 1px #0e1526 solid;
  padding: 10px 5px;
  color: #333;
}
table tr td:first-child,table tr td:last-child{
  border-left: 0;
}
table tr td em{
  color: #4087f1;
}
.van-cell .van-cell__left-icon{
  color: #4087f1;
}
.van-cell .van-cell__title{
  color: #4087f1;
  font-weight: 600;
}
</style>